import { useState } from 'react';
import { usePermissions, useTranslate } from 'react-admin';
import { Button } from '@mui/material';
import ImportIcon from '@/assets/icons/import-icon.svg?react';
import ImportDrawer from '@/components/global/import/ImportDrawer.jsx';

export const ProductCsvImportButton = () => {
    const { permissions } = usePermissions();
    const translate = useTranslate();
    const [importDrawerOpen, setImportDrawerOpen] = useState(false);

    if (!permissions.isAdmin) return null;

    const openImport = () => {
        setImportDrawerOpen(true);
    };

    return (
        <>
            <ImportDrawer
                open={importDrawerOpen}
                onClose={() => setImportDrawerOpen(false)}
                title={translate('resources.product.labels.importProductsFromCsv')}
                resource='product'
                dataTransformer='csv-product'
                placeholderText={translate('resources.product.labels.importCsvPlaceholder')}
            />
            <Button color='primary' size='small' startIcon={<ImportIcon />} onClick={openImport} sx={{ lineHeight: 1.5 }}>
                {translate('common.import')}
            </Button>
        </>
    );
};
